<div>
    <form (ngSubmit)="onSubmit()" [formGroup]="form" *ngIf="form">
        <div *ngFor="let question of questions">
            <vp-question
                [question]="question"
                (questionTrigger)="questionTrigger.emit($event)"
                [highlights]="highlights"
                [form]="form"
            ></vp-question>
        </div>
        <div *ngIf="!customSubmitEnabled" class="flex justify-end items-center">
            <div>
                <ng-content select="[bottomRightContent]"></ng-content>
            </div>
            <div>
                <button
                    *ngIf="!customConfirmEnabled"
                    type="submit"
                    mat-flat-button
                    class="ca-button ca-button-m flex ms-auto"
                    [caConfirm]="{
                        titleElement: confirmTitleElement,
                        contentElement: confirmContentElement,
                        cancelBtn: 'COMMON.BUTTONS.NO' | translate,
                        confirmBtn: 'COMMON.BUTTONS.YES' | translate,
                        disabled: !form.valid || !isValueDifferentThanCache || !onSubmitCacheConfig?.updateOnConfim
                    }"
                    (confirm)="updateCacheAndSubmit()"
                    (cancel)="restoreValueFromCache()"
                >
                    <ng-container *ngTemplateOutlet="buttonTextElement"></ng-container>
                </button>
                <button
                    *ngIf="customConfirmEnabled"
                    type="button"
                    mat-flat-button
                    class="ca-button ca-button-m flex ms-auto"
                    [caConfirm]="customConfirm"
                    (confirm)="onSubmit()"
                >
                    <ng-container *ngTemplateOutlet="buttonTextElement"></ng-container>
                </button>
            </div>
        </div>
    </form>
</div>

<ng-template #buttonTextElement>
    <ng-content select="[buttonText]"></ng-content>
</ng-template>

<ng-template #confirmTitleElement>
    <h4>{{ 'CONFIRM.CALCULATION_PROGRESS.TITLE' | translate }}</h4>
</ng-template>

<ng-template #confirmContentElement>
    {{ 'CONFIRM.CALCULATION_PROGRESS.CONTENT' | translate }}
</ng-template>
